import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import TextField from "@material-ui/core/TextField";
// import {KeyboardDatePicker} from "@material-ui/pickers";

import MakeAPICall from "../../apiCalls/common";


import {
    getConsultsApiRoute,
    countAppointmentsAPI
} from "../../apiRoutes";

// import {getFormattedDate, converToUtc} from "../../utils/dateTimeHelper";
// import {sortData} from "../../utils/commonMethods";

// import appRoutes from "../../routes/appRoutes";

import Loader from "../../components/loader";
import Button from "../../components/button";
// import ICPhoneDisplay from "../../components/phoneDisplay";
// import CustomDataTableSearchByFilter from "../../components/datatable/customDataTableSearchByFilter";
// import CustomModal from "../../components/modal";
// import DeviceDetails from "../../components/deviceDetails";
import ICCheckbox from "../../components/form/checkbox";
// import ICNoImg from "../../assets/images/noimg.png";
import moment from "moment";
import CustomModal from "../../components/modal";

// import MedicareClaimsExport from "../../containers/ConsultHistory/MedicareClaimsExport";
// import medicareImg from "../../assets/images/medicare-button.png";
// import AbaFileExport from "../../containers/ConsultHistory/AbaFileExport";
//
// import searchFilterList from "../../constants/searchFilterList";

const AppointmentCountsPage = props => {
    const [isProcessing, setProcessing] = useState(false);
    const [apiCallParams, setApiCallParams] = useState(null);
    const [natureOfConsults, setNatureOfConsults] = useState([]);
    const [showResponseModal, setShowResponseModal] = useState(false);
    const [modalText, setModalText] = useState("");

    const formik = useFormik({
        initialValues: {
            bilable: false,
            markedunsuccess: false,
            haveConnectionIssue: false,
            isBulkBilled: false,
            isPhoneCallUsed: false,
            isDependent: false,
            status: '',
            consultId: '',
            consultDetailId: '',
            appointmentPrice: '',
            startDate: '',
            endDate: ''
        },
        validationSchema: Yup.object({}),
        onSubmit: values => {
            setProcessing(true);

            let params = {};

            if (values.startDate && values.endDate) {
                params.startDate = moment(values.startDate, "YYYY-MM-DD").startOf('day').toISOString()
                params.endDate = moment(values.endDate, "YYYY-MM-DD").endOf('day').toISOString()
            }


            if (values.bilable) {
                params['bilable'] = true;
            }

            if (values.haveConnectionIssue) {
                params['haveConnectionIssue'] = true;
            }

            if (values.isBulkBilled) {
                params['isBulkBilled'] = true;
            }

            if (values.isDependent) {
                params['isDependent'] = true;
            }

            if (values.markedunsuccess) {
                params['markedunsuccess'] = true;
            }

            if (values.isPhoneCallUsed) {
                params['isPhoneCallUsed'] = true;
            }

            if (values.status) {
                params['status'] = +values.status;
            }

            if (values.consultId) {
                params['consultId'] = values.consultId;
            }

            if (values.consultDetailId) {
                params['consultDetailId'] = values.consultDetailId;
            }

            if (values.appointmentPrice !== '') {
                params['appointmentPrice'] = values.appointmentPrice;
            }


            setApiCallParams({
                reqType: "GET",
                reqUrl: countAppointmentsAPI,
                params: params,
                successCallback: async res => {
                    setModalText("There are " + res.data.data + " records");
                    setShowResponseModal(true);
                    setProcessing(false);
                },
                failureCallback: err => {
                    setModalText("Failed to get records because of" + err.message);
                    setShowResponseModal(true);
                    setProcessing(false);
                }
            });
        }
    });

    useEffect(() => {
        getConsults();
    }, [])

    const getConsults = () => {
        setNatureOfConsults(props.consultNatureList.map(consultData => ({
            id: consultData._id,
            consultName: consultData.consultName
        })));


        // setProcessing(true);
        //
        // setApiCallParams({
        //     reqType: "GET",
        //     reqUrl: getConsultsApiRoute,
        //     params: {
        //         skip: 0,
        //         limit: 0
        //     },
        //     successCallback: async res => {
        //         setNatureOfConsults(res.data.data.consultData.map(consultData => ({
        //             id: consultData._id,
        //             consultName: consultData.consultName
        //         })));
        //
        //         setProcessing(false);
        //     },
        //     failureCallback: err => {
        //         console.log(err);
        //         setProcessing(false);
        //     }
        // });
    };

    return (
        <Fragment>
            <CustomModal
                useOneButton={true}
                cancelText="OKAY"
                openModal={showResponseModal}
                cancelEvent={() => {
                    setShowResponseModal(false);
                    setModalText("");
                }}
                title="Instant Consult"
                modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
            />
            {isProcessing && <Loader />}
            <div className={isProcessing ? "disableContainer w-100" : "w-100"}>
                <div className="p-4">
                    <div className="row">
                        <div className="mt-4">
                            <h3 className="">Consult Request Details</h3>
                        </div>
                    </div>
                    <form
                        className="mt-4"
                        onSubmit={formik.handleSubmit}
                    >

                        <div className="row mt-4">
                            <div className="col-sm-4">
                                <div>
                                    <ICCheckbox
                                        name="bilable"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.bilable}
                                        inputProps={{ "aria-label": "primary checkbox" }}
                                        label="Billable"
                                    />
                                </div>
                                <div>
                                    <ICCheckbox
                                        name="markedunsuccess"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.markedunsuccess}
                                        inputProps={{ "aria-label": "primary checkbox" }}
                                        label="Marked Unsuccessful"
                                    />
                                </div>

                                <div>
                                    <ICCheckbox
                                        name="haveConnectionIssue"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.haveConnectionIssue}
                                        inputProps={{ "aria-label": "primary checkbox" }}
                                        label="Connection Issue Reported"
                                    />
                                </div>

                                <div>
                                    <ICCheckbox
                                        name="isBulkBilled"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.isBulkBilled}
                                        inputProps={{ "aria-label": "primary checkbox" }}
                                        label="Bulk Billed"
                                    />
                                </div>

                                <div>
                                    <ICCheckbox
                                        name="isPhoneCallUsed"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.isPhoneCallUsed}
                                        inputProps={{ "aria-label": "primary checkbox" }}
                                        label="Phone Call Used"
                                    />
                                </div>

                                <div>
                                    <ICCheckbox
                                        name="isDependent"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.isDependent}
                                        inputProps={{ "aria-label": "primary checkbox" }}
                                        label="Consult for Dependent"
                                    />
                                </div>
                            </div>

                            <div className="col-sm-6">
                                <div>
                                    <p className="mb-0 pb-0">Consult Dates</p>
                                    <TextField
                                        className="m-2"
                                        id="startDate"
                                        label="Start Date"
                                        type="date"
                                        variant="standard"
                                        defaultValue=""
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={formik.values.startDate}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />

                                    <TextField
                                        className="m-2"
                                        id="endDate"
                                        label="End Date"
                                        type="date"
                                        variant="standard"
                                        defaultValue=""
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={formik.values.endDate}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                <div className="mt-2">
                                    <TextField
                                        select
                                        SelectProps={{
                                            native: true
                                        }}
                                        name="status"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.status}
                                        className="w-100"
                                    >
                                        <option value=''>Select a Status</option>
                                        <option value="5">Completed</option>
                                        <option value="10">Cancelled by Patient</option>
                                        <option value="11">Rejected by Patient</option>
                                    </TextField>
                                </div>

                                <div className="mt-2">
                                    <TextField
                                        select
                                        SelectProps={{
                                            native: true
                                        }}
                                        name="consultId"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.consultId}
                                        className="w-100"
                                    >
                                        <option value=''>Select Nature of Consult</option>
                                        {natureOfConsults.map((value, index) => {
                                            return (<option key={value.id}
                                                value={value.id}>{value.consultName}</option>)
                                        })
                                        }
                                    </TextField>
                                </div>

                                <div className="mt-2">
                                    <TextField
                                        className="m-2"
                                        id="appointmentPrice"
                                        label="Consult Price > "
                                        type="number"
                                        variant="standard"
                                        defaultValue="0"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={formik.values.appointmentPrice}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-12 text-center mt-4">
                            <Button title="Calculate" className="m-auto" type="submit" />
                        </div>

                    </form>
                </div>
            </div>
            <MakeAPICall apiParam={apiCallParams} />
        </Fragment>
    );
};

const mapStateToProps = state => ({
    consultNatureList: state.serverConstants.consultNatureList
});

export default connect(mapStateToProps, null)(AppointmentCountsPage);
